import { render } from "./TenantGeneralSetting.vue?vue&type=template&id=86627f86"
import script from "./TenantGeneralSetting.vue?vue&type=script&lang=js"
export * from "./TenantGeneralSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__